import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Input, Row, Col, Select, Spin } from 'antd';
import {
  get,
  save,
  setPending,
} from '../redux/actions/ordenTrabajoInsumoActions';
import { get as getOrdenTrabajo } from '../redux/actions/ordenTrabajoActions';
import { getAllByParent as getActividadInversores } from '../redux/actions/actividadInversorActions';
import {
  ExclamationCircleOutlined,
  PlusOutlined,
  EditOutlined,
} from '@ant-design/icons';
import InsumoEditor from './InsumoEditor';
import { setPending as setPendingInsumo } from '../redux/actions/insumoActions';
import { compareObject } from '../utils/funtions';
import { callStatus } from '../utils/constants';
import cloneDeep from 'lodash/cloneDeep';
import { Notificacion } from './Notificacion';

import {
  DraggableModal,
  DraggableModalProvider,
} from 'ant-design-draggable-modal';
const { confirm } = Modal;
const { Option } = Select;
const OrdenTrabajoInsumoEditor = ({
  dispatch,
  id,
  parentId,
  stateData,
  visible,
  onCancel,
  insumo,
  inversor,
  actividadInversor,
  ordenTrabajoEstado,
  actividadId,
  ordenTrabajo,
}) => {
  const [form] = Form.useForm();

  const [showEditInsumo, setShowEditInsumo] = useState(false);
  const [insumoIdEdit, setInsumoIdEdit] = useState(null);
  const [insumoIdSelected, setInsumoIdSelected] = useState(null);

  const handleHideInsumoEditor = () => {
    setShowEditInsumo(false);
    setInsumoIdEdit(null);
    dispatch(setPendingInsumo());
  };

  const handleInsumoEdit = () => {
    setInsumoIdEdit(insumoIdSelected);
    setShowEditInsumo(true);
  };

  const handleInsumoCreate = () => {
    setInsumoIdEdit(null);
    setShowEditInsumo(true);
  };

  useEffect(() => {
    if (
      insumo.object.status === callStatus.OBJECT_SAVE_SUCCESS &&
      showEditInsumo
    ) {
      const saved = insumo.object.data;
      setResultSearchInsumo((prev) => {
        if (!prev.some((p) => p.id === saved.id)) return [...prev, saved];
        return prev.map((p) => (p.id === saved.id ? saved : p));
      });
      form.setFieldsValue({
        insumo_id: saved.id,
        precio_unitario: saved.precio,
      });
      setInsumoIdSelected(saved.id);
    }
  }, [insumo.object.status, showEditInsumo, insumo.object.data, form]);

  useEffect(() => {
    if (id) {
      dispatch(get(id));
    } else {
      dispatch(setPending());
    }
    if (parentId) {
      dispatch(getOrdenTrabajo(parentId));
    }
    if (actividadId) {
      dispatch(getActividadInversores(actividadId));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let data = cloneDeep(stateData.object.data);
    if (stateData.object.status === callStatus.OBJECT_SUCCESS) {
      form.setFieldsValue(data);
      setInitial(data);
      if (data.insumo) {
        setResultSearchInsumo([data.insumo]);
        setInsumoIdSelected(data.insumo_id || null);
      }
    } else if (stateData.object.status === callStatus.OBJECT_PENDING) {
      form.resetFields();
      setInitial({});
      setResultSearchInsumo([]);
      setInsumoIdSelected(null);
    } else if (stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS) {
      Notificacion('El registro se guardó con éxito', 'success', onCancel);
    } else if (stateData.object.status === callStatus.OBJECT_FAILED) {
      Notificacion(stateData.object.error, 'error', () => {});
    }

    // eslint-disable-next-line
  }, [stateData.object]);

  useEffect(() => {
    if (ordenTrabajo?.object?.status === callStatus.OBJECT_SUCCESS && !id) {
      form.setFieldsValue({ superficie: ordenTrabajo.object.data.superficie });
    }
    // eslint-disable-next-line
  }, [ordenTrabajo?.object?.status, id, form]);

  const onCreate = (data) => {
    data.orden_trabajo_id = parentId;

    if (
      (data.estado_id === 3 || data.estado_id === 4) &&
      (!data.importe || !data.inversor_id)
    ) {
      Notificacion(
        'Para Finalizar o Simular debe completar Importe e Inversor ',
        'error',
        () => {}
      );
    } else {
      dispatch(save(data));
    }
  };

  const [initial, setInitial] = useState({});

  const handleOnCancel = () => {
    if (compareObject(initial, form.getFieldsValue())) {
      confirm({
        title: 'Posee cambios sin guardar, desea continuar?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Si',
        cancelText: 'No',
        autoFocusButton: 'cancel',
        onOk() {
          onCancel();
        },
        onCancel() {},
      });
    } else {
      onCancel();
    }
  };
  const [resultSearchInsumo, setResultSearchInsumo] = useState([]);

  const onSearchInsumo = (value) => {
    const result = insumo.list.data.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase())
    );
    setResultSearchInsumo(result);
  };

  const handleChangeInsumo = (value) => {
    const ins = insumo.list.data.find((item) => item.id === value);
    if (ins) {
      const inversor_id = form.getFieldValue('inversor_id');
      let ganancia = 0;
      if (inversor_id && actividadInversor && actividadInversor.list.data) {
        const inversorData = actividadInversor.list.data.find(
          (item) => item.inversor_id === inversor_id
        );
        if (inversorData && inversorData.ganancia) {
          ganancia = parseFloat(inversorData.ganancia);
        }
      }
      let precio_final = parseFloat(ins.precio);
      if (ganancia > 0) {
        precio_final = precio_final * (1 + ganancia / 100);
      }
      form.setFieldsValue({ precio_unitario: precio_final.toFixed(3) });
    }
    setInsumoIdSelected(value);
    calcValues();
  };

  const handleInversorChange = (value) => {
    const ins_id = form.getFieldValue('insumo_id');
    if (ins_id) {
      const ins = insumo.list.data.find((item) => item.id === ins_id);
      if (ins) {
        let ganancia = 0;
        if (value && actividadInversor && actividadInversor.list.data) {
          const inversorData = actividadInversor.list.data.find(
            (item) => item.inversor_id === value
          );
          if (inversorData && inversorData.ganancia) {
            ganancia = parseFloat(inversorData.ganancia);
          }
        }
        let precio_final = parseFloat(ins.precio);
        if (ganancia > 0) {
          precio_final = precio_final * (1 + ganancia / 100);
        }
        form.setFieldsValue({ precio_unitario: precio_final.toFixed(3) });
      }
    }
    calcValues();
  };

  const calcValues = () => {
    setTimeout(() => {
      const total = form.getFieldValue('total');
      const superficie = form.getFieldValue('superficie');
      const precio_unitario = form.getFieldValue('precio_unitario');

      if (
        total &&
        superficie &&
        !isNaN(total) &&
        !isNaN(superficie) &&
        parseFloat(superficie) > 0
      ) {
        const dosis = parseFloat(total) / parseFloat(superficie);
        form.setFieldsValue({ dosis: dosis.toFixed(3) });
      }

      if (
        total &&
        precio_unitario &&
        !isNaN(total) &&
        !isNaN(precio_unitario)
      ) {
        const importe = parseFloat(total) * parseFloat(precio_unitario);
        form.setFieldsValue({ importe: importe.toFixed(3) });
      }
    }, 0);
  };

  return (
    <>
      <DraggableModalProvider>
        <DraggableModal
          mask
          initialWidth={600}
          initialHeight={600}
          maskClosable={false}
          visible={visible}
          title={stateData.object.data.id ? 'Editar Insumo' : 'Nuevo Insumo'}
          okText="Guardar"
          cancelText="Salir"
          onCancel={handleOnCancel}
          onOk={() => {
            form
              .validateFields()
              .then((values) => {
                onCreate(values);
              })
              .catch((info) => {
                console.log('Validate Failed:', info);
              });
          }}
        >
          <Spin
            spinning={
              stateData.object.status === callStatus.OBJECT_IN_PROCESS ||
              !!(id && stateData.object.status === callStatus.OBJECT_PENDING)
            }
          >
            <Form form={form} layout="vertical" name="form_in_modal">
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item name="id" label="id" style={{ display: 'none' }}>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={16} md={16} lg={16} xl={16}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item
                      name="insumo_id"
                      label="Insumo"
                      rules={[
                        {
                          required: true,
                          message: 'Requerido',
                        },
                      ]}
                      style={{ flex: 1 }}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={onSearchInsumo}
                        onChange={handleChangeInsumo}
                        notFoundContent={null}
                        allowClear
                      >
                        {resultSearchInsumo.map((item, index) => (
                          <Option key={index} value={item.id}>
                            {item.nombre}{' '}
                            {item.proveedor && `- (${item.proveedor.nombre})`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <div>
                      {insumoIdSelected ? (
                        <EditOutlined
                          onClick={handleInsumoEdit}
                          style={{ paddingLeft: '7px', cursor: 'pointer' }}
                        />
                      ) : (
                        <PlusOutlined
                          onClick={handleInsumoCreate}
                          style={{ paddingLeft: '7px', cursor: 'pointer' }}
                        />
                      )}
                    </div>
                  </div>
                </Col>

                <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                  <Form.Item
                    name="estado_id"
                    label="Estado"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Select>
                      {ordenTrabajoEstado.list.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                  <Form.Item
                    name="superficie"
                    label="Superficie a aplicar (Ha)"
                  >
                    <Input type="number" onBlur={calcValues} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                  <Form.Item name="total" label="Total de insumo (kg o ltr)">
                    <Input type="number" onBlur={calcValues} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                  <Form.Item name="dosis" label="Dosis por hectarea">
                    <Input type="number" readOnly />
                  </Form.Item>
                </Col>

                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Form.Item name="precio_unitario" label="Precio Unitario">
                    <Input
                      type="number"
                      addonBefore="U$D"
                      onBlur={calcValues}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <Form.Item name="importe" label="Importe">
                    <Input type="number" addonBefore="U$D" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item name="inversor_id" label="Aportante">
                    <Select allowClear onChange={handleInversorChange}>
                      {actividadInversor &&
                        actividadInversor.list.data.map((item) => (
                          <Select.Option key={item.id} value={item.inversor_id}>
                            {item.inversor?.nombre}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </DraggableModal>
        {showEditInsumo ? (
          <InsumoEditor
            id={insumoIdEdit}
            onCancel={handleHideInsumoEditor}
            visible={true}
          />
        ) : (
          false
        )}
      </DraggableModalProvider>
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    ordenTrabajoInsumo,
    insumo,
    inversor,
    ordenTrabajoEstado,
    actividadInversor,
    ordenTrabajo,
  } = state;
  const stateData = ordenTrabajoInsumo;
  return {
    stateData,
    insumo,
    inversor,
    actividadInversor,
    ordenTrabajoEstado,
    ordenTrabajo,
  };
};
export default connect(mapStateToProps)(OrdenTrabajoInsumoEditor);
